/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import IconButton from "@material-ui/core/IconButton";
import {makeStyles} from "@material-ui/core/styles";
import InputMask from 'react-input-mask';
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import usePersistentStore from "../../persistentStore";
import {useMutation, useQuery} from "@apollo/react-hooks";
import {CHECK_VERIFICATION_CODE, GET_USER, SEND_VERIFICATION} from "../../database/queries/userQueries";
import {notify} from "../../utils/notify";
import * as STATES from "../../constants/states";
import {useHistory, useParams} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    maskedInput: {
        height: '1em',
        font: 'inherit',
        color: 'currentColor',
        margin: 0,
        padding: 8,
        width: 80,
        textAlign: 'center',
        boxSizing: 'content-box',
        background: 'none',
        verticalAlign: 'middle',
    },
    gridItem: {
        margin: 30,
        textAlign: 'center'
    }
}));

const VerifyEmail = (props) => {
    const classes = useStyles();
    const [verificationCode, setVerificationCode] = useState('');
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [sent, setSent] = useState(false);
    const [verifiedUserId, setVerifiedUserId] = useState();

    const history = useHistory();
    let {userVerificationId} = useParams();

    const {refetch: getUserRefetch} = useQuery(GET_USER, {
        skip: !verifiedUserId,
        variables: {
            userId: verifiedUserId
        },
    });

    const [sendVerification] = useMutation(SEND_VERIFICATION);
    const [checkVerificationCode] = useMutation(CHECK_VERIFICATION_CODE);

    const handleChange = (e) => {
        let v = e.target.value;
        if (v) v = v.toUpperCase();
        setVerificationCode(v);
    };

    const sendVerify = () => { // need to change to callback
        if (!sent) {
            setSent(true);
            sendVerification({
                variables: {userId: globalPersistentState.me.userId}
            }).then(sendVerificationResult => {
                if (sendVerificationResult.data.sendVerification.returnCode === 0) {
                    notify('sendVerification', 'info', 'Verification email sent');
                    if (sendVerificationResult.data.sendVerification.verificationCode) {
                        notify('verificationCode', 'info', sendVerificationResult.data.sendVerification.verificationCode, false, 'verification-code')
                    }
                    console.log('## SVR verifyEmail ## changing history', '/verify-email/' + sendVerificationResult.data.sendVerification.userVerificationId);
                    history.push('/verify-email/' + sendVerificationResult.data.sendVerification.userVerificationId);
                } else {
                    notify('sendVerification', 'error', sendVerificationResult.data.sendVerification.message);
                }
            }).catch(e => {
                console.trace(e);
            });
        }
    };

    const checkCode = () => {
        checkVerificationCode({
            variables: {
                userVerificationId: userVerificationId,
                userId: globalPersistentState.me.userId,
                verificationCode: verificationCode,
            }
        }).then(checkVerificationCodeResult => {
            if (checkVerificationCodeResult.data.checkVerificationCode.returnCode === 0) {
                setVerifiedUserId(globalPersistentState.me.userId);
                getUserRefetch().then(getUserRefetchResult => {
                    globalPersistentActions.setMe(getUserRefetchResult.data.user);
                    globalPersistentActions.setState(STATES.LOGGED_IN);
                    console.log('## SVR verifyEmail ## changing history', '/dashboard');
                    history.push('/dashboard');
                }).catch(e => {
                    notify('checkCode', 'error', 'Problem fetching user!');
                })
            } else {
                notify('checkCode', 'error', checkVerificationCodeResult.data.checkVerificationCode.message);
            }
        }).catch(e => {
            console.trace(e);
        });
    };

    useEffect(() => {
        if (!userVerificationId && globalPersistentState.me && globalPersistentState.me.userId) {
            sendVerify();
        } else if (!globalPersistentState.me || !globalPersistentState.me.userId) {
            console.log('## SVR verifyEmail ## changing history', '/sign-in');
            history.push('/sign-in');
        }
    }, [globalPersistentState.me, userVerificationId, sendVerify]);

    return (
        <Container>
            <Grid container>
                <Grid item xs={12} className={classes.gridItem}>
                    <Typography>
                        Welcome to JunctionBox.io. Please verify your email address by entering the 6 character code we
                        sent to you.
                        <br/>
                        If you do not see the email in your inbox, please check your spam folder.
                    </Typography>
                </Grid>
                {userVerificationId && (
                    <Grid item xs={12} className={classes.gridItem}>
                        <InputMask
                            mask="******"
                            maskChar=""
                            id="verification-code-input"
                            value={verificationCode}
                            className={classes.maskedInput}
                            onChange={handleChange}
                        />
                        {verificationCode && verificationCode.length === 6 && (
                            <IconButton
                                id="verify-button"
                                aria-controls="verify-button"
                                color="primary"
                                aria-label="verify-button"
                                onClick={checkCode}
                            >
                                <ArrowForwardIcon/>
                            </IconButton>
                        )}
                    </Grid>
                )}
                {globalPersistentState.me && (<Grid item xs={12} className={classes.gridItem}>
                    <Link onClick={() => {
                        setVerificationCode('');
                        setSent(false);
                        sendVerify();
                    }}>Resend verification code</Link>
                </Grid>)}
            </Grid>
        </Container>
    )
};

export default VerifyEmail;
